import { App } from "vue"
// Import shepherd styles - load default styles first, then our customizations
import "shepherd.js/dist/css/shepherd.css"
// Make sure to load our custom theme after the default styles
import "@/assets/styles/shepherd-quasar-theme.scss"

// Import vue-shepherd plugin for Options API
import VueShepherdPlugin from "vue-shepherd"

export default {
   install: (app: App) => {
      // Use the plugin with Options API
      // @ts-expect-error - vue-shepherd doesn't have proper TypeScript definitions
      app.use(VueShepherdPlugin)
   },
}
